export enum FormPartType {
    OrderDetail = "orderDetails",
    Input = "input",
    Terms = "terms",
    Select = "select",
    MarketingConsent = "marketing_consent",
    AgreementCheckbox = "agreementCheckbox",
}

export type FormPartComponent<FP extends SupportedFormParts> = {
    formPart: FP,
    onValueChange: (formPartType: string, value: string|object) => void,
    onValidStatusChange: (formPartType: string, value: boolean) => void,
    answers: object[]|string[]|string,
    errors: string[]|string[][]
};

export type SupportedFormParts = OrderDetail | Input | Terms | Select | MarketingConsent | AgreementCheckbox;

export type FormPart<T extends FormPartType, TS extends object = object> = {
    type: T;
    key: string;
} & TS;

export type OrderDetail = FormPart<FormPartType.OrderDetail, {
    label: string,
    email: {
        label: string,
    },
    first_name: {
        label: string,
    },
    last_name: {
        label: string,
    },
    hasTerms: boolean,
    terms: {
        termsAndConditionsUrl: string,
        companyName: string,
    } | undefined
}>;

export type Terms = FormPart<FormPartType.Terms, {
    terms: {
        termsAndConditionsUrl: string,
        companyName: string,
    }
}>;

export type Input = FormPart<FormPartType.Input, {
    label: string,
    inputType: "text" | "date" | "telephone",
    description: string | null,
    placeholder: string | null,
    required: boolean,
}>;

export type Select = FormPart<FormPartType.Select, {
    label: string,
    description: string | null,
    placeholder: string | null,
    required: boolean,
    options: Array<{ key: string, value: string }>,
}>;

export type MarketingConsent = FormPart<FormPartType.MarketingConsent, {
    label: string,
    // Optional muted sub-text shown under the checkbox label.
    description?: string,
    required: boolean,
    // Which marketing channels accepting this checkbox opts the buyer into (email/sms/ads/whatsapp).
    channels: string[],
}>;

export type AgreementCheckbox = FormPart<FormPartType.AgreementCheckbox, {
    label: string,
    description: string | null,
    linkUrl: string | null,
    linkText: string | null,
    required: boolean,
}>;
